module.exports = __webpack_public_path__ + "static/media/bg-congratu.22a57dc3.png";